'use strict';

var shallowDiff = require('shallow-diff');
var shallowCopy = require('shallow-copy');

var onlyClassificationsChanged = require('./classification-counts-need-updating/only-classifications-changed');

var onlyWorkTypeChanged = function onlyWorkTypeChanged(diff) {
  return diff.updated.length === 1 && diff.updated[0] === 'worktype';
};

var filterCounts = function filterCounts(newParams, newCounts, lastParams, lastCounts) {
  if (!newCounts && !lastCounts) {
    return undefined;
  }

  if (newCounts) {
    return newCounts;
  }

  var calculatedCounts = {};
  var diff = shallowDiff(lastParams, newParams);

  if (onlyWorkTypeChanged(diff)) {
    calculatedCounts.worktype = shallowCopy(lastCounts.worktype);
  } else if (onlyClassificationsChanged(diff)) {
    calculatedCounts.classification = shallowCopy(lastCounts.classification);
  }

  return calculatedCounts;
};

module.exports = filterCounts;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/step-counts.js
 ** module id = 472
 ** module chunks = 0
 **/